import React, {  Fragment } from 'react';

import { TextValidator } from 'react-material-ui-form-validator';
import Button from '@mui/material/Button';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';

import { AutoTextValidator } from './GridComponents';

/*
<LocationBox 
locTemplates = {this.state.locTemplates}
locTemplate = {this.state.locTemplate}
onChange = {this.onAutoChange} ###3
classes = {classes}
onAddLocationTemplate = {this.onAddLocationTemplate} ###
onTextChange = {this.onTextChange} ###
locationName = {this.state.locationName}
locationStreet = {this.state.locationStreet}
locationCity = {this.state.locationCity}
counties = {this.state.counties}       ***************
locationCounty = {this.state.locationCounty}
locationStateCode = {this.state.locationStateCode}
states = {this.state.states}
onStateChange = {this.onStateChange} ###
locationZipcode = {this.state.locationZipcode}
locationMapURL = {this.state.locationMapURL}
/>
*/

const LocationBox = props => {

    const { classes } = props;

    return (
        <>
            <Grid container  spacing={3}>
            <Grid item xs={12}>
                        <br />
                        <FormLabel component="legend">{"Location"}</FormLabel>
                        <p>Select a saved location from the list. If your location is not listed, fill in the fields below, then click Save Location.</p>
                    </Grid>
                    <Grid item xs={6}>
                        <AutoTextValidator
                            name="locTemplate"
                            options={props.locTemplates}
                            value={props.locTemplate}
                            onChange={props.onAutoChange}
                            classes={classes}
                            label="Saved Location"
                        />
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                        <TextValidator
                            id="standard-basic"
                            label="Location Name"
                            type="text"
                            className={[classes.textField].join(' ')}
                            onChange={props.onTextChange}
                            value={props.locationName}
                            name='locationName'
                            validators={['required']}
                            errorMessages={['Location name is required']}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextValidator
                            id="standard-basic"
                            label="Street"
                            type="text"
                            className={[classes.textField].join(' ')}
                            onChange={props.onTextChange}
                            value={ props.locationStreet || '' }
                            name='locationStreet'
                            validators={['required']}
                            errorMessages={['Street is required']}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                        <TextValidator
                            id="standard-basic"
                            label="City"
                            type="text"
                            className={[classes.textField].join(' ')}
                            onChange={props.onTextChange}
                            value={props.locationCity || ''}
                            name='locationCity'
                            validators={['required']}
                            errorMessages={['City is required']}
                            fullWidth
                            required
                        />
                    </Grid>
                   
                    <Grid item xs={12} sm={6} lg={3}>
                        
                        <AutoTextValidator
                            name="stateCode"
                            options={ props.states}
                            value={ props.locationStateCode }
                            onChange={props.onStateChange}
                            classes={classes}
                            validators={['required']}
                            errorMessages={['State Code is required']}
                            label="State"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3}>

                        <AutoTextValidator
                            name="locationCounty"
                            options={ props.counties}
                            value={ props.locationCounty}
                            onChange={props.onAutoChange}
                            classes={classes}
                            validators={['required']}
                            errorMessages={['County is required']}
                            label="County"
                            disabled={ props.locationStateCode===null}
                        />

                       
                    </Grid>

                    <Grid item xs={12} sm={6} lg={3}>
                        <TextValidator
                            id="standard-basic"
                            label="Zipcode"
                            type="text"
                            className={[classes.textField].join(' ')}
                            onChange={props.onTextChange}
                            value={ props.locationZipcode || '' }
                            name='locationZipcode'
                            validators={['required']}
                            errorMessages={['Zipcode is required']}
                            fullWidth
                            required
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextValidator
                            id="standard-basic"
                            label="Map URL"
                            type="text"
                            className={[classes.textField].join(' ')}
                            onChange={props.onTextChange}
                            value={ props.locationMapURL || ''}
                            name='locationMapURL'
                            fullWidth
                        />
                        
                    </Grid>
                    
                    <Grid item xs={3} >

                            {!props.locTemplate  &&
                            <Button
                                variant="outlined" 
                                color="primary"
                                className={[].join(' ')}
                                onClick={props.onAddLocationTemplate}
                            >
                                Save Location
                            </Button>
                            }

                            {/* {props.locTemplate  &&
                            <Button
                                variant="outlined" 
                                color="primary"
                                className={[].join(' ')}
                                href="mailto:gi.bmp@ifas.ufl.edu?subject=Update Location Template"
                            >
                                Email Admin to Update Location Template
                            </Button>
                            } */}

                    </Grid>
            </Grid>
        </>

    )
}

export default LocationBox;
//export default TrainingHist